"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FORM_TEXT_AREA_FIELD = void 0;
const FORM_TEXT_AREA_FIELD = exports.FORM_TEXT_AREA_FIELD = 'form-text-area-field';
